import React, { useState, useEffect } from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, Legend, ResponsiveContainer, CartesianGrid } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { TrendingUp } from 'lucide-react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const MonthlyRevenueChart = () => {
  const [months, setMonths] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = () => axios.get(`${BACKEND_URL}/api/invoices/reports/monthly-summary`)
      .then((res) => setMonths(res.data.months || []))
      .catch(() => {})
      .finally(() => setLoading(false));
    load();
    const onFocus = () => load();
    window.addEventListener('focus', onFocus);
    return () => window.removeEventListener('focus', onFocus);
  }, []);

  if (loading || months.every((m) => m.invoiced === 0)) return null;

  return (
    <Card className="mb-6" data-testid="monthly-revenue-chart">
      <CardHeader className="pb-2">
        <CardTitle className="flex items-center gap-2 text-base">
          <TrendingUp size={18} className="text-[#5c1a1a]" />
          Monthly Revenue — Last 12 Months
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ResponsiveContainer width="100%" height={260}>
          <BarChart data={months} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
            <CartesianGrid strokeDasharray="3 3" stroke="#eee" />
            <XAxis dataKey="label" tick={{ fontSize: 11 }} />
            <YAxis tick={{ fontSize: 11 }} tickFormatter={(v) => `$${v >= 1000 ? (v / 1000).toFixed(0) + 'k' : v}`} />
            <Tooltip formatter={(v, name) => [`$${Number(v).toFixed(2)}`, name]} />
            <Legend wrapperStyle={{ fontSize: 12 }} />
            <Bar dataKey="invoiced" name="Invoiced" fill="#5c1a1a" radius={[3, 3, 0, 0]} />
            <Bar dataKey="collected" name="Collected" fill="#16a34a" radius={[3, 3, 0, 0]} />
            <Bar dataKey="outstanding" name="Outstanding" fill="#dc2626" radius={[3, 3, 0, 0]} />
          </BarChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
};
